import React, { useRef } from 'react';
import TechIcon from '../../../Utils/Icons/Icons';
import PortfolioCard from './PortfolioCard';
import './Portfolio.css';

const PortfolioCarousel = ({ section }) => {
  const containerRef = useRef(null);

  const scroll = (direction) => {
    const container = containerRef.current;
    if (!container) return;

    const cardWidth = container.querySelector('.portfolioCardWrapper')?.offsetWidth || 0;
    const gap = 18;
    const scrollAmount = direction === "right" ? cardWidth + gap : -(cardWidth + gap);

    container.scrollBy({
      left: scrollAmount,
      behavior: "smooth",
    });
  };

  return (
    <div className="portfolioSubsection">
      <div className="portfolioHeader">
        <div>
          <h2>
            <span className="portfolioHighlight">{section.category}</span>
          </h2>
          <p className="portfolioSectionDesc">{section.description}</p>
        </div>

        <div className="portfolioChevIcons">
          <button onClick={() => scroll("left")} aria-label="Scroll left">
            <TechIcon name="arrow-left" size={20} />
          </button>
          <button onClick={() => scroll("right")} aria-label="Scroll right">
            <TechIcon name="arrow-right" size={20} />
          </button>
        </div>
      </div>

      <div className='protfolioCardSlide'>
      <div className="portfolioCardsContainer" ref={containerRef}>
        {section.projects.map((project) => (
          <div className="portfolioCardWrapper" key={project.id}>
            <PortfolioCard project={project} />
          </div>
        ))}
      </div>
      </div>
    </div>
  );
};

export default PortfolioCarousel;
